<rh-ui-global-header 
  headerInput="Routehappy Hub"
  [isSearchVisibleInput]="false"
  [isServicesIconVisibleInput]="false"
  [isNotificationIconVisibleInput]="false"
  [isHelpIconVisibleInput]="false">
</rh-ui-global-header>
<div class="access-denied__container">
  <rh-ui-icon class="link-color" iconInput="alert-circle" [isIconRefInput]="true" [heightInput]="20"></rh-ui-icon>
  <p class="access-denied link-color">Access denied</p>
  <p>To continue, you'll need to request access from your administrator or create an <a class="link link-color" href="https://atpco.service-now.com/spi">ATPCO Support Ticket</a>.</p>
  <hr>
  <p>If you believe you already have access, try logging in again.</p>
  <rh-ui-button
    labelInput="Sign out"
    [appearanceInput]="VisualAppearance.fill"
    (clickEventOutput)="logout()">
  </rh-ui-button>
</div>
